import styled from 'styled-components';
import { media, colorUtils, colors, layout } from '@prisjakt/ui-base';
import { Link as LinkComponent } from 'react-router-dom';

export const Banner = styled(LinkComponent)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  padding: ${layout.spacing.medium};
  margin-bottom: ${layout.spacing.xSmall};
  background: ${colorUtils.setRgbaAlpha(colors.lightBlue1, '0.1')};

  ${media.smallOnly`
    flex-direction: column;
    align-items: center;
  `};
`;

export const Badge = styled.div`
  width: 140px;
  margin-right: ${layout.spacing.small};

  ${media.smallOnly`
    margin-right: 0;
    margin-bottom: ${layout.spacing.small};
  `};
`;

export const Header = styled.div`
  h2 {
    font-size: 24px;
    font-weight: 600;

    ${media.smallOnly`
    text-align: center;
  `};
  }

  ${media.smallOnly`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 10px;
  `};
`;

export const Content = styled.div`
  ${media.smallOnly`
    text-align: center;
  `};
`;

export const Link = styled(LinkComponent)`
  color: ${p => p.theme.text.callToAction};

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;
